<template>
  <div>
    <luci-btn-icon :config="backBtnConfig" @callback="$router.push({ name: 'LanguageList' })"></luci-btn-icon>

    <v-alert v-if="error" :value="true" color="error" icon="error" class="error-container">
      <span class="error-span luci-text white--text">{{ error }}</span>
    </v-alert>

    <div v-if="isLoading" class="loading">
      <img src="../../assets/images/icons/loading-pmc.gif" alt="'Loading">
    </div>

    <luci-form v-if="!isLoading" v-model="formData" :config="formConfig" @submit="submitForm" @reset="resetForm" @callback="$router.push({ name: 'LanguageList' })"></luci-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import variables from '../../helpers/variables'

export default {
  data () {
    return {
      backBtnConfig: variables.backBtnIconOptions
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'language/update/isLoading',
      error: 'language/update/error',
      retrieved: 'language/update/retrieved',
      updated: 'language/update/updated',
      violations: 'language/update/violations'
    }),
    formData: {
      get () {
        return this.retrieved ? this.retrieved : { name: '', code: '' }
      },
      set (value) {
        this.$store.dispatch('language/update/updateRetrieved', value)
      }
    },
    formConfig () {
      return (
        {
          name: 'form-edit-language',
          title: 'Details',
          description: 'To update language please change the form below.',
          showButtonAsIcon: true,
          buttons: variables.formButtons,
          fields: [
            {
              order: 1,
              element: 'input',
              required: true,
              name: 'name',
              label: 'name',
              inputConfig: { type: 'text', placeholder: 'Please enter language name', clearable: true }
            },
            {
              order: 2,
              element: 'input',
              required: true,
              name: 'code',
              label: 'code',
              inputConfig: { type: 'text', placeholder: 'Please enter the ISO 639-1 Code', clearable: true }
            }
          ]
        }
      )
    }
  },
  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },
  methods: {
    ...mapActions({
      retrieve: 'language/update/retrieve',
      update: 'language/update/update',
      updateRetrieved: 'language/update/updateRetrieved'
    }),
    resetForm () {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    },
    submitForm () {
      this.update()
        .then(() => {
          if (!this.error) {
            this.$router.push({ name: 'LanguageList' })
          }
        })
    }
  }
}
</script>
